import React from 'react';
import { Box, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { useAccessControl } from '../../hooks/useAccessControl';
import PayrollDeductionsComponent from '../payrollsheet/tabs/PayrollDeductions';

const PayrollDeductions = () => {
  const { canAccessPayroll } = useAccessControl();
  const bgColor = useColorModeValue("white", "gray.800");

  if (!canAccessPayroll()) {
    return (
      <Box p={6} bg={bgColor} borderRadius="lg" shadow="sm">
        <VStack spacing={4} align="center">
          <Heading size="lg" color="red.500">Access Denied</Heading>
          <Text color="gray.600">
            You don't have permission to access payroll deductions.
          </Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box p={6} bg={bgColor} borderRadius="lg" shadow="sm">
      <VStack spacing={6} align="stretch">
        {/* <Box>
          <Heading size="lg" mb={2}>Payroll Deductions</Heading>
          <Text color="gray.600">
            Manage and view all payroll deductions for your organization.
          </Text>
        </Box> */}
        
        <PayrollDeductionsComponent />
      </VStack>
    </Box>
  );
};

export default PayrollDeductions;